import { connect } from 'react-redux';
import React, { Component } from 'react';
import { renderKBSelect, renderKBUserInput, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';

import { bindActionCreators } from 'redux';
import * as valid from 'utils/validate';
import { apiCallFailure } from 'app/actions';
import {
KBInput,
KBRadio,
KBFormError,
KBButton,
KBDepartmentInput,
KBPopover,
KBPopoverTop } from
'components';
import * as selectors from 'app/selectors';

const GROUP_ROLES = [
{
  id: 'location_group_operator',
  name: '项目负责人' },

{
  id: 'location_group_wechat_manager',
  name: '项目活动负责人' },

{
  id: 'location_group_content_manager',
  name: '项目内容管理员' }];


var MemberGroupRolesSettingsForm = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.addMemberLocationRoles = this.addMemberLocationRoles.bind(this);}getInitialState()
  {
    return {
      settings: null };

  }componentDidMount()

  {}addMemberLocationRoles(

  model) {
    //const { locationsData, apiCallFailureActions } = this.props
    //const { location_id, role} = model
    // if(role == 'location_manager'){
    //   let nowLocation = locationsData.filter( location => {
    //     return location.id == location_id
    //   })
    //   let hasLocationManager = nowLocation && nowLocation[0].team.find(team => team.is_manager == true )
    //   if(hasLocationManager){
    //     apiCallFailureActions({
    //       status: 'error',
    //       message :'此分店已经设置负责人,如需更改请到分店设置中进行修改!'
    //     })
    //     return
    //   }
    // }

    const { callBack } = this.props;
    model.enabled = 'true';
    KBPopoverTop.close();
    callBack && callBack(model);
  }render()

  {
    const {
      fields: { role, location_group_id },
      error,
      submitting,
      handleSubmit,
      location_groups } =
    this.props;

    return (
      <form onSubmit={handleSubmit(this.addMemberLocationRoles)}>
        <KBFormError error={this.props.error} />
        <div className="kb-form-header">
          <h2 className="header-title">添加项目权限</h2>
          <i
          className="iconfont header-close icon-cancel"
          onClick={KBPopoverTop.close} />

        </div>
        <div className="kb-form-container">
          <div className="kb-row">
            <Field name="location_group_id" component={renderKBUserInput}
            title="项目"
            placeholder="选择项目"
            className="kb-form-group kb-form-c18 kb-form-alone"

            isRequired={true}
            multi={false}
            users={location_groups}
            selectedUsers={[]} />

          </div>
          <div className="kb-row">
            <Field name="role" component={renderKBSelect}
            defaultValue=" "
            className="kb-form-group kb-div-c18 kb-form-alone"
            title="角色"
            isRequired={true}

            arrayData={GROUP_ROLES} />

          </div>
          <div className="kb-row fixed-form-btn">
            <span className="cancel-btn" onClick={KBPopoverTop.close}>
              取消
            </span>
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              保存
            </KBButton>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  const { user } = state;
  const location_groups = selectors.getLocationGroups(state);
  //const locationsData = selectors.getLocations(state) || []

  return {
    user,
    location_groups
    //locationsData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiCallFailureActions: bindActionCreators(apiCallFailure, dispatch) };

}

const validate = values => {
  const errors = {};
  if (valid.required(values.role)) {
    errors.role = '请选择项目角色';
  }

  if (valid.required(values.location_group_id)) {
    errors.location_group_id = '请选择项目';
  }
  return errors;
};

const LEGACY_FORM_FIELDS = [
  "role",
  "location_group_id"
];

const formConfig = {
  form: 'MemberGroupRolesSettingsForm',
  touchOnBlur: false,
  validate: validate };


MemberGroupRolesSettingsForm = connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('MemberGroupRolesSettingsForm', LEGACY_FORM_FIELDS)(MemberGroupRolesSettingsForm)));

export default MemberGroupRolesSettingsForm;
